/**
 * Created by calhosh on 12/20/2022
 */
import Skeleton from 'react-loading-skeleton';
import React from 'react';
import styled from 'styled-components';
export default function AresTabLoader() {
	return (
		<SkeletonHeaderWrapper className="SkeletonHeaderWrapper">
			<Skeleton count={5} height={24} width={100} />
		</SkeletonHeaderWrapper>
	);
}
const SkeletonHeaderWrapper = styled.section`
	padding: 0 var(--px-20) 0 var(--px-40);
	height: auto;
	margin-bottom: 0;
	display: flex;
	flex-direction: column;
	align-self: center;
	.react-loading-skeleton {
		margin: var(--px-15) var(--px-20) var(--px-5) var(--px-20);
		background-color: var(--neutrals-200);
		background-size: 200px 100%;
		display: inline-block;
		line-height: 1;
		width: 100%;
		background-repeat: no-repeat;
		border-radius: var(--px-4);
		animation: 1.2s ease-in-out 0s infinite normal none running animation-16jpnkj;
	}
`;
